import BottomAppBar from "../../components/BottomBar";
import MainCard from "../../components/MainCard";
import Navigation from "../../components/Navigation";
import HomeContent from "../../components/home/HomeContent";

const Home = () => {
  return (
    <div>
      <Navigation title={"HOME"} appBarColor="orange" />
      <div className="fixed-layout-main flex flex-col">
        <div className="w-[95%] mx-auto my-2">
          <MainCard />
        </div>

        <div className="homewhite-card mt-0 flex-1 ">
          <HomeContent />
        </div>
      </div>

      <BottomAppBar />
    </div>
  );
};

export default Home;
